// extracted by mini-css-extract-plugin
export default {"notice":"InfoNotice_notice__Y4fMV","info":"InfoNotice_info__wYPX1","warning":"InfoNotice_warning__VxYEk","error":"InfoNotice_error__pubjH","success":"InfoNotice_success__qzdmN"};